$(document).ready(function () {
  const image = document.getElementById("main-crop-image");
  $(".upload-crop-image").change(function () {
    console.log("tessst");
    readURL(this);
  });
  var cropper;
  var rotatevalue = 90;

  function readURL(input) {
    $(".err-message").remove();
    $(".select-orientaion").removeClass("active");
    $(".select-orientaion.portrait").addClass("active");
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        $(".modal-content-croppopup")
          .find(".image-wrapper img")
          .attr("src", e.target.result);
        if (cropper != null) {
          cropper.destroy();
        }
        cropper = new Cropper(image, {
          viewMode: 0,
          scalable: true,
          zoomable: true,
          aspectRatio: 0.716,
          cropBoxMovable: true,
          cropBoxResizable: true,
          preview: true,
          crop(event) {},
          ready() {
            cropper.reset();
             
          },
        });
        var contData = cropper.getContainerData(); //Get container data
        cropper.setCropBoxData({ height: contData.height, width: contData.width  }) 
      };
      reader.readAsDataURL(input.files[0]);

      $(".modal-croppopup").fadeIn();
    }
  }

  $(".rotate-image").click(function () {
    if (cropper != null) {
      cropper.rotateTo(rotatevalue);
      rotatevalue = rotatevalue + 90;
      if (rotatevalue == 360) {
        rotatevalue = 0;
      }
    }
  });

  $(".setselectedbutton").click(function () {
    var croppeddata = cropper.getCroppedCanvas({
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });
    $(".cropped-image-output").attr("src", croppeddata.toDataURL("image/png"));
    $(".cropped-image-output-wrapper").show();
    $(".select-image-wrapper").hide();
    $(".previewimageinput").val(croppeddata.toDataURL("image/png"));
    console.log(
      "portrait " + $(".select-orientaion.portrait").hasClass("active")
    );
    console.log(
      "landscape " + $(".select-orientaion.landscape").hasClass("active")
    );
    if ($(".select-orientaion.portrait").hasClass("active")) {
      $("product-media").attr("data-display", "portrait");
      $('.product__thumbnail-item[data-alt="portrait"]').eq(0).click();
    }
    if ($(".select-orientaion.landscape").hasClass("active")) {
      $("product-media").attr("data-display", "landscape");
      $('.product__thumbnail-item[data-alt="landscape"]').eq(0).click();
    }
    $(".modal-croppopup").fadeOut();
    var isMobile = window.matchMedia(
      "only screen and (max-width: 1000px)"
    ).matches;

    if (isMobile) {
      $(".reselect-image.mobileonly").show();
    } else {
      $(".reselect-image.desktoponly").show();
    }
    $(".user-text-on-image").show();
    var event = new CustomEvent("variant:changed");
    document.dispatchEvent(event);
    cropper.getCroppedCanvas().toBlob((blob) => {
      var file = new File([blob], "my_image.png", {
        type: "image/png",
        lastModified: new Date().getTime(),
      });
      const fileInput = document.querySelector(
        'input[type="file"][name="properties[_Cropped Image]"]'
      );

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      fileInput.files = dataTransfer.files;
    
    }, "image/png");
    $("product-media").attr("data-hascropped", true);
  });

  $(".close-croppopup").click(function () {
    $(".modal-croppopup").fadeOut();
  });

  $(".upload-new-image").change(function () {
    console.log("tessst");
    readURL(this);
  });
  $(".change-selected-image").click(function () {
    console.log("tessst");
    $(".modal-croppopup").fadeIn();
  });

  $(".select-orientaion.landscape").click(function () {
    $(".select-orientaion").removeClass("active");
    $(this).addClass("active");
    $(".image-wrapper").find("img").css("aspect-ratio", 1.414);
    setTimeout(function () {
      cropper.destroy();
      cropper = new Cropper(image, {
        viewMode: 0,
        scalable: true,
        zoomable: true,
        aspectRatio: 1.414,
        cropBoxMovable: true,
        cropBoxResizable: true,
        preview: true,
        crop(event) {},
        ready() {
 
        },
      });
      var contData = cropper.getContainerData(); //Get container data
        cropper.setCropBoxData({ height: contData.height, width: contData.width  }) 
    }, 100);
  });

  $(".select-orientaion.portrait").click(function () {
    $(".select-orientaion").removeClass("active");
    $(this).addClass("active");
    $(".image-wrapper").find("img").css("aspect-ratio", 0.716);
    setTimeout(function () {
      cropper.destroy();
      cropper = new Cropper(image, {
        viewMode: 0,
        scalable: true,
        zoomable: true,
        aspectRatio: 0.716,
        cropBoxMovable: true,
        cropBoxResizable: true,
        crop(event) {},
        ready() {
          
        },
      });
      var contData = cropper.getContainerData(); //Get container data
        cropper.setCropBoxData({ height: contData.height, width: contData.width  }) 
    }, 100);
  });

  $(".line-item-heading")
    .find("input")
    .keyup(function () {
      $(".user-text-on-image").find(".user-heading").html($(this).val());
    });

  $(".line-item-subheading")
    .find("textarea")
    .keyup(function () {
      $(".user-text-on-image").find(".user-subheading").html($(this).val());
    });
  $(".line-item-position")
    .find("select")
    .change(function () {
      $(".user-text-on-image")
        .removeAttr("class")
        .addClass("user-text-on-image");
      if ($(this).val() == "Top Left") {
        $(".user-text-on-image").addClass("top-left");
      } else if ($(this).val() == "Top Center") {
        $(".user-text-on-image").addClass("top-center");
      } else if ($(this).val() == "Top Right") {
        $(".user-text-on-image").addClass("top-right");
      } else if ($(this).val() == "Middle Left") {
        $(".user-text-on-image").addClass("middle-left");
      } else if ($(this).val() == "Middle Center") {
        $(".user-text-on-image").addClass("middle-center");
      } else if ($(this).val() == "Middle Right") {
        $(".user-text-on-image").addClass("middle-right");
      } else if ($(this).val() == "Bottom Left") {
        $(".user-text-on-image").addClass("bottom-left");
      } else if ($(this).val() == "Bottom Center") {
        $(".user-text-on-image").addClass("bottom-center");
      } else if ($(this).val() == "Bottom Right") {
        $(".user-text-on-image").addClass("bottom-right");
      }
    });
  $(".line-item-color")
    .find("input")
    .on("input", function () {
      $(".user-text-on-image").css("color", $(this).val());
    });
  $(".product__thumbnail-item").click(function () {
    if (
      $(
        'input[name="option2"][value="' +
          $(this).attr("data-color") +
          '"]:checked'
      ).length == 0
    ) {
      $(
        'input[name="option2"][value="' + $(this).attr("data-color") + '"]'
      ).prop("checked", true);
      $(
        'input[name="option2"][value="' + $(this).attr("data-color") + '"]'
      ).trigger("change");
    }
  });

  $('input[name="option2"]').change(function () {
    setTimeout(function () {
      console.log(
        $(
          '.product__thumbnail-item[data-alt="' +
            $("product-media").attr("data-display") +
            '"][data-color="' +
            $('input[name="option2"]:checked').val() +
            '"]'
        ).length
      );
      $(
        '.product__thumbnail-item[data-alt="' +
          $("product-media").attr("data-display") +
          '"][data-color="' +
          $('input[name="option2"]:checked').val() +
          '"]'
      ).click();
    }, 200);
  });
  $('.line_item_addborder').find('input').change(function(){
    var ischecked= $(this).is(':checked');
    if(ischecked){
      $('.cropped-image-output').removeClass('nospacing');
      $('.cropped-image-output').addClass('spacing');
      $('.user-text-on-image').removeClass('nospacing');
      $('.user-text-on-image').addClass('spacing');
    }else{
      $('.cropped-image-output').removeClass('spacing');
      $('.cropped-image-output').addClass('nospacing');
      $('.user-text-on-image').removeClass('spacing');
      $('.user-text-on-image').addClass('nospacing');
    }
  })
});
